import React, { Component } from "react";
import CartContext from "./CartContext";
import { SideMenu } from "./SideMenu";
import { BiRefresh } from "react-icons/bi";
import { BsFillPencilFill } from "react-icons/bs";
import { MessageBox } from "./MessageBox";
import { LoadSpinner } from "./LoadSpinner";
import Select from "react-select";

import {
  OverlayTrigger,
  Tabs,
  Tab,
  Tooltip,
  Button,
  ButtonToolbar,
  Form,
  Row,
  Col,
  Modal,
  Nav,
  Table,
  Navbar,
} from "react-bootstrap";

export class ManufacturingRawMaterials extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);
    this.state = {
      rawMaterialId: "",
      rawMaterialName: "",
      unit: "",
      price: "",
      qty: "1",
      details: "",
      statusId: 1,
      rawmaterials: [],
      firstload: false,

      // validation errors
      errors: {},
    };
  }

  GetProductLabelName = (product) => {
    var result = product.name;

    if (product.batchId != undefined && product.batchId != "")
      result +=
        this.context.store.businessTypeId ==
        this.context.BusinessTypes.STEELTRADERS
          ? " CoilId:" + product.batchId
          : " BatchId:" + product.batchId;

    if (product.hsnCode != undefined && product.hsnCode != "")
      result += " HSNCode:" + product.hsnCode;
    return result;
  };

  LoadRawMaterials = () => {
    {
      var pd = [];
      this.props.rawMaterialsInventory
        .filter(
          (f) => f.warehouseId == this.props.manufacturingRequest.warehouseId
        )
        .map((r) =>
          pd.push({
            value: r.id,
            label: this.GetProductLabelName(r),
          })
        );
      this.setState({ rawmaterials: pd });
    }
  };

  GetPriceOfRawMaterial = (id) => {
    var result = this.props.rawMaterialsInventory.filter((f) => f.id == id);
    if (result.length > 0) return result[0].purchasePrice;
    return 0;
  };
  GetUnitOfRawMaterial = (id) => {
    var result = this.props.rawMaterialsInventory.filter((f) => f.id == id);
    if (result.length > 0) return result[0].unit;
    return "";
  };

  // Clear specific field validation error
  clearError = (field) => {
    const errors = { ...this.state.errors };
    if (errors[field]) {
      delete errors[field];
      this.setState({ errors });
    }
  };

  handleItemsInputChange = (e) => {
    const { name, value } = e.target;

    switch (name.trim()) {
      case "qty":
        this.setState({ qty: value }, () => this.clearError("qty"));
        break;
      case "details":
        this.setState({ details: value }, () => this.clearError("details"));
        break;
      default:
        break;
    }
  };

  handleSubmit = (event) => {
    // prevent default if event exists (button click)
    if (event && event.preventDefault) event.preventDefault();

    // validation
    const errors = {};
    if (!this.state.rawMaterialId || this.state.rawMaterialId === "") {
      errors.rawMaterialId = "Select a raw material.";
    }

    const qtyNum = parseFloat(this.state.qty);
    if (!this.state.qty || isNaN(qtyNum) || qtyNum <= 0) {
      errors.qty = "Enter a valid quantity greater than zero.";
    }

    if (!this.state.details || (this.state.details || "").trim() === "") {
      errors.details = "Provide details for the raw material.";
    }

    if (Object.keys(errors).length > 0) {
      // set errors and focus first invalid
      this.setState({ errors }, () => {
        // focus logic: rawMaterial select -> qty input -> details textarea
        if (errors.rawMaterialId) {
          const sel = document.getElementById("productName");
          if (sel) sel.focus();
        } else if (errors.qty) {
          const q = document.querySelector("input[name='qty']");
          if (q) q.focus();
        } else if (errors.details) {
          const d = document.querySelector("textarea[name='details']");
          if (d) d.focus();
        }
      });
      return;
    }

    // no validation errors — proceed with original behaviour
    if (this.props.Type == "Add") {
      this.props.AddManufacturingRawMaterial({
        rawMaterialId: this.state.rawMaterialId,
        rawMaterialName: this.state.rawMaterialName,
        unit: this.state.unit,
        price: Math.round(this.state.price, 0),
        qty: this.state.qty,
        details: this.state.details,
        statusId: this.state.statusId,
      });
    } else {
      this.props.UpdateManufacturingRawMaterial(
        {
          rawMaterialId: this.state.rawMaterialId,
          rawMaterialName: this.state.rawMaterialName,
          unit: this.state.unit,
          price: Math.round(this.state.price, 0),
          qty: this.state.qty,
          details: this.state.details,
          statusId: this.state.statusId,
        },
        this.props.Index
      );
    }
  };

  OnRawMaterialNameChange = (e) => {
    this.setState(
      {
        rawMaterialId: e.value,
        rawMaterialName: e.label,
        price: this.GetPriceOfRawMaterial(e.value),
        unit: this.GetUnitOfRawMaterial(e.value),
      },
      () => this.clearError("rawMaterialId")
    );
  };
  GetRawMaterialName = (id) => {
    var list = this.state.rawmaterials.filter((f) => f.value == id);
    if (list.length > 0) return list[0].label;
    return "";
  };
  componentDidMount = () => {
    if (this.state.firstload == false) {
      this.state.firstload = true;

      this.LoadRawMaterials();
    }
    if (document.getElementById("productName") != null)
      document.getElementById("productName").focus();

    // If editing, populate state from props (preserve existing behavior)
    if (this.props.Type === "Edit" && this.props.manufacturingRawMaterial) {
      const m = this.props.manufacturingRawMaterial;
      this.setState({
        rawMaterialId: m.rawMaterialId,
        rawMaterialName: m.rawMaterialName,
        unit: m.unit,
        price: m.price,
        qty: m.qty,
        details: m.details,
        statusId: m.statusId ?? 1,
      });
    }
  };

  render() {
    const { errors } = this.state;

    return (
      <>
        <div className="container ">
          <Modal
            {...this.props}
            size="xl"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            show={true}
            backdrop="static"
            keyboard={false}
            dialogClassName="CouponModal"
          >
            <Modal.Header closeButton className="bg-primary text-light">
              <Modal.Title id="contained-modal-title-vcenter">
                {this.props.Type == "Edit"
                  ? "Edit Purchase Item"
                  : "Add Purchase Item"}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body className="show-grid ">
              <Row className="m-2 p-2 bg-light " style={{ fontSize: "12pt" }}>
                <Col md={12}>
                  <Form.Group as={Row} className="mb-1 " controlId="">
                    <Form.Label column sm="3">
                      RawMaterial Name
                    </Form.Label>
                    <Col sm="9">
                      <Select
                        name="productName"
                        id="productName"
                        autoFocus
                        value={{
                          value: this.state.rawMaterialId,
                          label: this.GetRawMaterialName(
                            this.state.rawMaterialId
                          ),
                        }}
                        onChange={(e) => this.OnRawMaterialNameChange(e)}
                        options={this.state.rawmaterials}
                      ></Select>
                      {errors.rawMaterialId && (
                        <div className="text-danger small mt-1">
                          {errors.rawMaterialId}
                        </div>
                      )}
                    </Col>
                  </Form.Group>

                  <Form.Group as={Row} className="mb-1 " controlId="">
                    <Form.Label column sm="3">
                      Qty / Wt Required
                    </Form.Label>
                    <Col sm="5">
                      <Form.Control
                        type="decimal"
                        size="lg"
                        className="pd-2 w-100"
                        name="qty"
                        required
                        value={this.state.qty}
                        placeholder=""
                        autoComplete="off"
                        onChange={(e) => this.handleItemsInputChange(e)}
                        isInvalid={!!errors.qty}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.qty}
                      </Form.Control.Feedback>
                    </Col>
                    <Col sm="4">
                      <Form.Control
                        type="text"
                        size="lg"
                        className="pd-2 w-100"
                        name="unit"
                        readOnly
                        value={this.state.unit}
                        placeholder=""
                        autoComplete="off"
                      />
                    </Col>
                  </Form.Group>

                  <Form.Group as={Row} className="mb-1 " controlId="">
                    <Form.Label column sm="3">
                      Details
                    </Form.Label>
                    <Col sm="9">
                      <Form.Control
                        as="textarea"
                        type="textarea"
                        rows={3}
                        maxLength={499}
                        size="lg"
                        className="pd-2 w-100"
                        name="details"
                        value={this.state.details}
                        placeholder=""
                        autoComplete="off"
                        onChange={(e) => this.handleItemsInputChange(e)}
                      />
                    </Col>
                  </Form.Group>

                  <Form.Group as={Row} className="mb-1 " controlId="">
                    <Form.Label column sm="3">
                      Status
                    </Form.Label>
                    <Col sm="9">
                      <Form.Select
                        type="text"
                        size="lg"
                        className="pd-2 w-100"
                        name="statusId"
                        required
                        disabled
                        value={this.state.statusId}
                        placeholder=""
                        autoComplete="off"
                        onChange={(e) => this.handleItemsInputChange(e)}
                      >
                        <option value="1">Request</option>
                        <option value="2">Delivered</option>
                        <option value="3">OutOfStock</option>
                      </Form.Select>
                    </Col>
                  </Form.Group>
                </Col>
              </Row>
            </Modal.Body>
            <Modal.Footer className="bg-light">
              <Form.Group>
                <Button variant="primary" size="lg" onClick={this.handleSubmit}>
                  {this.props.Type == "Add" ? "Add" : "Update"}
                </Button>
              </Form.Group>

              <Button variant="danger" size="lg" onClick={this.props.onHide}>
                Close
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
      </>
    );
  }
}

export default ManufacturingRawMaterials;
